export enum ValidationType {
    Required = 'required',
    Min = 'min',
    Max = 'max',
    Size = 'size',
    Count = 'count',
    Decimal = 'decimal',
    Email = 'email',
    URL = 'url',
    Phone = 'phone',
    INN = 'inn',
    Russian = 'russian',
    RegExp = 'regexp',
}
